export const displayTypeItems = [
    {
        name: "numeric",
        display: "#",
    },
    {
        name: "percentage",
        display: "%",
    },
];

export enum EDisplayType {
    NUMBER,
    PERCENTAGE,
}
